__turbopack_context__.v({
  "magnolia-validity": "magnolia-cms-validity-component-module-scss-module__mM35ja__magnolia-validity",
  "magnolia-validity__identifier": "magnolia-cms-validity-component-module-scss-module__mM35ja__magnolia-validity__identifier",
  "magnolia-validity__identifier--active": "magnolia-cms-validity-component-module-scss-module__mM35ja__magnolia-validity__identifier--active",
  "magnolia-validity__identifier--future": "magnolia-cms-validity-component-module-scss-module__mM35ja__magnolia-validity__identifier--future",
  "magnolia-validity__identifier--outdated": "magnolia-cms-validity-component-module-scss-module__mM35ja__magnolia-validity__identifier--outdated",
});
